import { type Never } from '../../../../base/Entity'
import {
  PersistedType,
  type PersistedTypePrimaryKeyType,
  type PersistedTypeAttributesType
} from './Ambiguous'

export type UnloadedPersistedTypeAttributesType = Never<PersistedTypeAttributesType>

export class UnloadedPersistedType extends PersistedType<UnloadedPersistedTypeAttributesType> {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor (primaryKey: PersistedTypePrimaryKeyType) {
    super(primaryKey)
  }

  readonly isLoaded: false = false
}
